import { useEffect } from "react";
import EventManager from "../EventManager/EventManager";
import { FRAME_EVENT } from "../consts/Frame";

const eventManager = EventManager.getInstance();

const RefreshLogoutManager = () => {
    const onUnload = (e) => {
        e.preventDefault();
        e.returnValue = "";
    };

    useEffect(() => {
        const unsubscribe = eventManager.subscribe((type, data) => {
            if (
                type === FRAME_EVENT.USER_LOGGEDIN_STATUS &&
                data.componentName === "add_data"
            ) {
                window.addEventListener("beforeunload", onUnload);
            } else if (
                type === FRAME_EVENT.USER_LOGGEDIN_STATUS &&
                data.componentName === "cleanrooms"
            ) {
                window.removeEventListener("beforeunload", onUnload);
            } else if (type === FRAME_EVENT.RELOAD_WINDOW) {
                window.removeEventListener("beforeunload", onUnload);
                const auth0Url = data?.auth0Url;
                const currentURL = window.location.origin;
                const logoutUrl = `${window?.location?.protocol}//${auth0Url}/v2/logout?returnTo=${currentURL}`;
                if (!!auth0Url && currentURL) {
                    window.location.href = logoutUrl;
                } else {
                    window.location.reload();
                }
            }
        });

        return () => {
            window.removeEventListener("beforeunload", onUnload);
            unsubscribe();
        };
    }, []);

    return null;
};

export default RefreshLogoutManager;
